import { render, staticRenderFns } from "./AssignOrdersFailedToDeliver.vue?vue&type=template&id=650e97f2&scoped=true&"
import script from "./AssignOrdersFailedToDeliver.vue?vue&type=script&lang=js&"
export * from "./AssignOrdersFailedToDeliver.vue?vue&type=script&lang=js&"
import style0 from "./AssignOrdersFailedToDeliver.vue?vue&type=style&index=0&id=650e97f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e97f2",
  null
  
)

export default component.exports